import "./styles.css";

import CTAWpp from "../../components/CTAWpp";

import content1 from "../../assets/content1.png";
import lp from "../../assets/lp.png";
import content1Mobile from "../../assets/mobile/content1.png";
import lpMobile from "../../assets/mobile/lp.png";
import smMobile from "../../assets/mobile/sm.png";
import sm from "../../assets/sm.png";

const Content = () => {
  return (
    <section id="content">
      <article className="content1">
        <div className="container">
          <h2 className="title">Nossos Números</h2>

          <figure className="info">
            <img
              src={
                /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
                  navigator.userAgent
                )
                  ? content1Mobile
                  : content1
              }
              alt="Cases"
            />
          </figure>

          <CTAWpp />
        </div>
      </article>

      <article className="content2">
        <div className="container">
          <h2 className="title">Serviços Adicionas que também oferecemos</h2>

          <div className="gallery">
            <div className="item">
              <figure className="top">
                <img
                  src={
                    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
                      navigator.userAgent
                    )
                      ? lpMobile
                      : lp
                  }
                  alt="Landing Page"
                />
              </figure>

              <CTAWpp />
            </div>

            <div className="item">
              <figure className="top">
                <img
                  src={
                    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
                      navigator.userAgent
                    )
                      ? smMobile
                      : sm
                  }
                  alt="Pacote Social Media"
                />
              </figure>

              <CTAWpp />
            </div>
          </div>
        </div>
      </article>
    </section>
  );
};

export default Content;
